import React from 'react';
import PropTypes from 'prop-types';

import MetsIcon from 'commons/components/MetsIcon';

function NumberedSectionTitle(props) {

    return (
        <div className={"numbered-section-title " + (props.className ?? "")}>
            {props.currentSection > props.sectionNumber ?
                <MetsIcon name="svg_checkmarkCircle3" className="numbered-section-complete-icon" />
            :
                <span className="number">{props.sectionNumber}</span>
            }
            <h2>{props.title}</h2>
            {props.children && <div className="numbered-section-title-extra">
                {props.children}
            </div>
            }
        </div>
    );

}

NumberedSectionTitle.propTypes = {
    /** Additional content to display under the section title. */
    children: PropTypes.node,
    /** A custom className for the widget. */
    className: PropTypes.string,
    /** The current section number the user has reached in the context of the entire User Registration */
    currentSection: PropTypes.number,
    /** The section number of the section that this NumberSectionTitle belongs to. */
    sectionNumber: PropTypes.number,
    /** The title of the section. */
    title: PropTypes.string
}

export default NumberedSectionTitle;